import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { TextblockModel } from 'projects/core/src/lib/models/textblock.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TEXT_TYPES } from 'projects/core/src/lib/constants';

@Component({
  selector: 'app-textblock-basedata',
  templateUrl: './textblock-basedata.component.html',
  styleUrls: ['./textblock-basedata.component.scss']
})
export class TextblockBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() textblock: TextblockModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public optionsTypes: Array<SelectItem> = [];
  public form = this.fb.group({
    identifier: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.optionsTypes = FormHelper.getSelectList(TEXT_TYPES, null, this.transloco);
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.textblock !== null) {
      if (this.auth.hasRight('admin.textblock.create')) {
        this.items.push({
          label: this.transloco.translate('common.labels.duplicate'),
          icon: 'pi pi-copy',
          command: () => {
            this.onDuplicate();
          }
        });
      }
      if (this.auth.hasRight('admin.textblock.delete')) {
        this.items.push({
          label: this.transloco.translate('common.labels.delete'),
          icon: 'pi pi-trash',
          styleClass: 'danger-button',
          disabled: (!this.textblock.deletable),
          command: () => {
            this.onDelete();
          }
        });
      }
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('textblocks', this.textblock.id, this.form.value).subscribe({
        next: (result: any) => {
          this.textblock.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.textblock.identifier }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.textblock.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.textblock.identifier }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('textblocks', this.textblock.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.textblock.identifier }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/contents/textblocks']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  onDuplicate(): void {
    if (this.auth.hasRight('admin.textblock.create')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_duplicate', { value: this.textblock.identifier }),
        header: this.transloco.translate('common.really_duplicate'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.duplicateTextblock(this.textblock.id).subscribe({
            next: (result: any) => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.duplicated', { value: this.textblock.identifier }), this.transloco.translate('common.duplicated'));
              this.router.navigate(['/contents/textblocks', result.data.id]);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.textblock !== null) {
      this.form.patchValue({
        identifier: this.textblock.identifier,
        type: this.textblock.type,
        description: this.textblock.description,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
